import React from 'react';
import { UserPlus, UserMinus, Shield, Trophy, Check, Crown } from 'lucide-react';
import { MANAGER_POWERS, MANAGER_POWERS_OUTRO } from '../managerPowers';

// Named rather than imported into the copy module, which stays free of React so it
// can be read as the wording it is.
const ICONS = {
  invite: UserPlus,
  remove: UserMinus,
  gaffer: Shield,
  league: Trophy,
  approve: Check,
  crown: Crown,
};

/**
 * What the manager gets on top, as a step in both create wizards.
 *
 * It earns a step of its own for the same reason the Gaffer decision does: on the
 * review panel it would be a line somebody scrolls past on the way to the submit
 * button, and this is the one screen where the difference between "you are in a
 * game" and "you are running one" is ever explained.
 *
 * Nothing here is a field, so the step is complete the moment it renders and Next
 * is never blocked. It is deliberately the last stop before Review: by then the
 * decisions are made, so it reads as what you have just taken on rather than as
 * more of the form.
 *
 * Every row shows its default beside it, and that pairing is the whole design -
 * see `managerPowers.js`. A power with nothing next to it is read as a duty.
 */
function ManagerPowersStep({ kind }) {
  const copy = MANAGER_POWERS[kind];

  return (
    <>
      <p className="helper-text wizard-intro">{copy.intro}</p>

      <ul className="manager-powers">
        {copy.powers.map((power) => {
          const Icon = ICONS[power.icon];
          return (
            <li key={power.id} className="manager-power">
              <Icon size={18} className="manager-power-icon" aria-hidden="true" />
              <div className="manager-power-text">
                <span className="manager-power-name">{power.name}</span>
                {/* The label is styled rather than punctuated so the eye can skip the
                    whole column once it has learnt what it says. */}
                <span className="manager-power-default">
                  <span className="manager-power-default-label">Leave it</span>
                  {power.fallback}
                </span>
              </div>
            </li>
          );
        })}
      </ul>

      <p className="helper-text manager-powers-outro">{MANAGER_POWERS_OUTRO}</p>
    </>
  );
}

export default ManagerPowersStep;
